import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  SUPPORTED_UI_LOCALE_OPTIONS,
  normalizeLocale,
  persistLocale,
} from "../i18n/config";

export const useUiLocale = () => {
  const { i18n } = useTranslation("app");

  const locale = useMemo(() => {
    return normalizeLocale(i18n.resolvedLanguage || i18n.language);
  }, [i18n.language, i18n.resolvedLanguage]);

  const setLocale = useCallback(
    async (nextLocale) => {
      const normalizedLocale = normalizeLocale(nextLocale);
      persistLocale(normalizedLocale);
      await i18n.changeLanguage(normalizedLocale);
    },
    [i18n],
  );

  const supportedLocales = useMemo(() => {
    return SUPPORTED_UI_LOCALE_OPTIONS.map((option) => ({
      code: option.code,
      label: option.nativeLabel,
    }));
  }, []);

  return {
    locale,
    setLocale,
    supportedLocales,
  };
};

export default useUiLocale;
